function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("title", null, "C9EDF62D-78C7-4C8B-B8E2-6E00D0FF944B"), /*#__PURE__*/React.createElement("g", {
  stroke: "#141D2E",
  className: styles["cross"] || "cross",
  fill: "none",
  fillRule: "evenodd",
  opacity: "0.200000003",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,-2.41166526 L9,20.4116653",
  transform: "rotate(45 9 9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9,-2.41166526 L9,20.4116653",
  transform: "scale(-1 1) rotate(45 0 -12.728)"
}))));